module.exports = __webpack_public_path__ + "static/media/female-workout-image.c6dddcaf.png";